/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_PeriodInputs */

const en_usage_period = /** @type {(inputs: Usage_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Period`)
};

const fr_usage_period = /** @type {(inputs: Usage_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période`)
};

const de_usage_period = /** @type {(inputs: Usage_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitraum`)
};

const it_usage_period = /** @type {(inputs: Usage_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo`)
};

const ru_usage_period = /** @type {(inputs: Usage_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Период`)
};

const es_usage_period = /** @type {(inputs: Usage_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período`)
};

const zh_cn2_usage_period = /** @type {(inputs: Usage_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时期`)
};

const ja_usage_period = /** @type {(inputs: Usage_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期間`)
};

const hi_usage_period = /** @type {(inputs: Usage_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवधि`)
};

const pt_pt2_usage_period = /** @type {(inputs: Usage_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período`)
};

/**
* | output |
* | --- |
* | "Period" |
*
* @param {Usage_PeriodInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_period = /** @type {((inputs?: Usage_PeriodInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_PeriodInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_period(inputs)
	if (locale === "de") return de_usage_period(inputs)
	if (locale === "it") return it_usage_period(inputs)
	if (locale === "ru") return ru_usage_period(inputs)
	if (locale === "es") return es_usage_period(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_period(inputs)
	if (locale === "ja") return ja_usage_period(inputs)
	if (locale === "hi") return hi_usage_period(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_period(inputs)
	return en_usage_period(inputs)
});